import { Button } from "antd";
import type { ReactNode } from "react";

type Props = {
  children?: ReactNode;
  [key: string]: any;
};

// eslint-disable-next-line react/prop-types
export const DefaultButton: React.FC<Props> = ({ children, ...props }) => {
  return (
    <Button type="primary" className="text-upper" {...props}>
      {children}
    </Button>
  );
};
